<template>
  <div v-if="shouldShow" class="flex items-center justify-end gap-2 w-full px-3 py-1.5" data-testid="ocr-toolbar" @click.stop>
    <template v-if="artifactsStore.isOcrProcessing">
      <Icon name="general.spinner" size="sm" class="text-zinc-400 dark:text-zinc-500" />
      <span class="text-xs text-zinc-500 dark:text-zinc-400" data-testid="ocr-processing-label"> Detecting text... </span>
    </template>

    <template v-else-if="artifactsStore.isOcrDone && !artifactsStore.hasOcrData">
      <span class="text-xs text-zinc-500 dark:text-zinc-400" data-testid="ocr-no-text-label"> No text detected </span>
    </template>

    <template v-else-if="artifactsStore.isOcrDone && artifactsStore.hasOcrData">
      <!-- Default mode -->
      <template v-if="!artifactsStore.selectionMode">
        <Button
          type="ghost"
          variant="black"
          icon="general.textFields"
          text="Select text"
          data-testid="ocr-select-text-button"
          @click="artifactsStore.enterSelectionMode()"
        />
        <Button type="ghost" variant="black" icon="general.copyFileFolder" text="Copy all text" data-testid="ocr-copy-all-button" @click="copyAll" />
      </template>

      <!-- Selection mode -->
      <template v-else>
        <span class="text-xs text-zinc-700 dark:text-zinc-300" data-testid="ocr-selection-count"> {{ artifactsStore.selectedCount }} selected </span>
        <Button
          type="solid"
          variant="blue"
          icon="general.copyFileFolder"
          text="Copy Selected"
          :disabled="!artifactsStore.hasSelection"
          data-testid="ocr-copy-selected-button"
          @click="copySelected"
        />
        <Button type="ghost" variant="black" text="Cancel" data-testid="ocr-cancel-selection-button" @click="artifactsStore.exitSelectionMode()" />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useArtifactsStore } from '../../store/useArtifactsStore';
import { useViewerTrack, TrackEvents } from '../../composables/useViewerTrack';
import { Button, Icon } from '@/storybook';

const artifactsStore = useArtifactsStore();
const { trackItemOwner } = useViewerTrack();

const shouldShow = computed(() => {
  return artifactsStore.isOcrProcessing || artifactsStore.isOcrDone;
});

const copyAll = () => {
  artifactsStore.copyAllText();
  trackItemOwner(TrackEvents.VIEWER_OCR_TEXT_COPIED, {
    copy_type: 'all',
    line_count: artifactsStore.ocrLines.length,
  });
};

const copySelected = () => {
  const lineCount = artifactsStore.selectedCount;
  artifactsStore.copySelectedText();
  trackItemOwner(TrackEvents.VIEWER_OCR_TEXT_COPIED, {
    copy_type: 'selected',
    line_count: lineCount,
  });
};
</script>
